import React from 'react';
import { YDialog } from '../../../ui/dialog/YDialog';
import { YButton } from '../../../ui/YButton';
import { formatPlantedAtLabel, formatPlantingAcres } from './plantingLogUtils';

export function PlantingMissingPlanDialog({ event, show = false, onHide }) {
  const dateLabel = formatPlantedAtLabel(event?.planted_at);
  const acres = formatPlantingAcres(event?.acres);
  const bits = [event?.plan_name, dateLabel, event?.blend_name, acres].filter(Boolean);

  return (
    <YDialog
      show={Boolean(show && event)}
      onHide={onHide}
      title="This plan no longer exists"
      size="sm"
      testId="plant-log-missing-plan-dialog"
      footer={(
        <YButton variant="primary" type="button" onClick={onHide}>
          Close
        </YButton>
      )}
    >
      <p className="plant-plans-log-missing__body">
        The planting log row is still here. The live recipe was deleted.
      </p>
      {bits.length ? (
        <p className="plant-plans-log-missing__frozen" data-testid="plant-log-missing-plan-labels">
          {bits.join(' · ')}
        </p>
      ) : null}
    </YDialog>
  );
}
